/**
* @typedef {Object} Store
* @property {Function} commit
* @property {Function} dispatch
* @property {S} state
* @property {G} getters
* @property {any} rootState
* @property {any} rootGetters
* @template S,G
*/
/**
* @callback GetterFunction
* @param {S} state
* @param {G} getters
* @param {any} rootState
* @param {any} rootGetters
* @returns {T}
* @template T,S,G
*/
/**
* @callback ActionFunction
* @param {Store<S,G>} store
* @param {T} params
* @returns {Promise<R>}
* @template T,R,S,G
*/

import global from './global'
import auth from './auth'
import responsive, { ResizePlugin } from './responsive'
import consent, { ConsentPlugin } from './consent'
import booking from './booking'
import hotelData from './hotelData'
import rooms from './rooms'
import cart from './cart/cart'
import currency from './currency'
import variants from './variants'
import overlay from './overlay'
import i18n from './i18n'
import validations from './validations'
import modifyReservation from './modifyReservation'
import spaSoft from './spaSoft'

export default {
  global,
  auth,
  responsive,
  consent,
  booking,
  hotelData,
  rooms,
  cart,
  currency,
  variants,
  overlay,
  i18n,
  validations,
  modifyReservation,
  spaSoft
}

export const Plugins = [
  ResizePlugin,
  ConsentPlugin,
]
